import React, { useCallback } from "react";
import cn from "classnames";
import { CellContext } from "@tanstack/react-table";
import { t } from "i18next";
import { Trans } from "react-i18next";
import { XMarkIcon } from "@heroicons/react/20/solid";
import useShowMessage from "oneclick-component/src/hooks/useShowMessage";
import { Button } from "oneclick-component/src/components/Button";
import { useRemoveShiftFullTimeAttendanceHandlerShiftFullTimeAttendancesAttendanceIdDeleteMutation as useRemoveFullTime } from "oneclick-component/src/store/apis/enhancedApi";
import { useShowError } from "../../hooks/useShowError";
import { ShiftFullTimeAttendanceRecord } from "./useShiftFullTimeAttendanceTable";

export const RemoveAction = ({
  row,
}: CellContext<
  ShiftFullTimeAttendanceRecord,
  unknown
>): React.ReactElement | null => {
  const showMessage = useShowMessage();
  const { showError } = useShowError();
  const [removeFullTime, { isLoading }] = useRemoveFullTime();
  const removeAttendance = useCallback(() => {
    removeFullTime({
      attendanceId: row.original.id,
    })
      .unwrap()
      .then(() => {
        showMessage({
          title: t("fulltimeAttendance.remove.success"),
          type: "success",
          showDismiss: true,
        });
      })
      .catch((e) => {
        showError(e, t("fulltimeAttendance.remove.fail"));
      });
  }, [row, removeFullTime, showError, showMessage]);
  return (
    <div>
      <Button
        theme="white"
        className={cn("h-6", "text-xs", "text-black/60")}
        iconClassName="!fill-black/60"
        prefixIcon={XMarkIcon}
        onClick={removeAttendance}
        disabled={isLoading}
      >
        <Trans i18nKey="fulltimeAttendance.list.column.action.remove" />
      </Button>
    </div>
  );
};
